import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, reset } from 'redux-form';
import CustomerProductDetailDialog from './customerProductDetailDialog';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
  values: getFormValues('CustomerProductDetail')(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('CustomerProductDetail'),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CustomerProductDetailDialog);
